(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("InnovaccerDesignSystem"), require("MDSHelpers"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["InnovaccerDesignSystem", "MDSHelpers", "react", "react-dom"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("InnovaccerDesignSystem"), require("MDSHelpers"), require("react"), require("react-dom")) : factory(root["InnovaccerDesignSystem"], root["MDSHelpers"], root["React"], root["ReactDOM"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, (__WEBPACK_EXTERNAL_MODULE__73957__, __WEBPACK_EXTERNAL_MODULE__73297__, __WEBPACK_EXTERNAL_MODULE__44119__, __WEBPACK_EXTERNAL_MODULE__89545__) => {
return 